import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputFieldComponent } from '@zayan-erp/shared';
import { JobTypeService } from '../../services/job-type.service';
import { JobType } from '../../models/lots.models';
import { ActivatedRoute, Router } from '@angular/router';
import { DynamicRouteHandlingService } from 'libs/shared/src/lib/services/dynamic-route-handling.service';

@Component({
  selector: 'lib-job-type-form',
  standalone: true,
  imports: [InputFieldComponent, ReactiveFormsModule],
  templateUrl: './job-type-form.component.html'
})
export class JobTypeFormComponent {
  #jobTypeService = inject(JobTypeService);
  #activatedRoute = inject(ActivatedRoute);
  #dynamicRouteHandling = inject(DynamicRouteHandlingService);
  #router = inject(Router);
  from = new FormGroup({
    code: new FormControl<string | null>(null, Validators.required),
    description: new FormControl<string | null>(null, Validators.required),
    abbreviation: new FormControl<string | null>(null, [Validators.maxLength(10)])
  });
  selectedJobId: string | null = null;

  constructor() {
    this.selectedJobId = this.#activatedRoute.snapshot.params['id'];
    if (this.selectedJobId) {
      this.#jobTypeService.getJobTypeById(this.selectedJobId).subscribe(jobType => {
        this.from.patchValue({
          abbreviation: jobType?.abbreviation,
          description: jobType?.description,
          code: jobType?.code
        });
      });
    }

    this.#dynamicRouteHandling.submitButton.pipe(takeUntilDestroyed()).subscribe(() => this.submit());
  }

  submit() {
    if (this.from.invalid) {
      this.from.markAllAsTouched();
      return;
    }

    const formData = this.from.value;
    if (!this.selectedJobId) {
      this.#jobTypeService.createJobType(formData as JobType).subscribe({
        next: () => this.onFormSuccessfulSubmit()
      });
    } else {
      this.#jobTypeService.updateJobType(formData as JobType, this.selectedJobId).subscribe({
        next: () => this.onFormSuccessfulSubmit()
      });
    }
  }

  onFormSuccessfulSubmit() {
    this.#dynamicRouteHandling.reload.next(!this.#dynamicRouteHandling.reload.value);
    this.#router.navigate(['/home-building/job-types']);
    this.from.reset();
  }
}
